import { render, staticRenderFns } from "./OficioEncerramento.vue?vue&type=template&id=5794784b"
import script from "./OficioEncerramento.vue?vue&type=script&lang=js"
export * from "./OficioEncerramento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports